// extracted by mini-css-extract-plugin
export var cardLayout = "_64-1";
export var paginationContainer = "_64-0";